import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58c22dda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "g-toggle-button" }
const _hoisted_2 = {
  for: "default-toggle",
  class: "inline-flex relative items-center cursor-pointer"
}
const _hoisted_3 = ["value"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-11 h-6 rounded-full peer bg-light-gary-color peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600" }, null, -1))
const _hoisted_5 = { class: "ml-3 text-sm text-breadcrumb-color" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        type: "checkbox",
        id: "default-toggle",
        class: "sr-only peer",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model) = $event)),
        value: _ctx.value,
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.change && _ctx.change(...args)))
      }, null, 40, _hoisted_3), [
        [_vModelCheckbox, _ctx.model]
      ]),
      _hoisted_4,
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.label), 1)
    ])
  ]))
}